const SKIP_TO_MAIN_ID = 'skip-to-main-content';

const handleClick = (e) => {
  e.preventDefault();
  const skipElem = e.currentTarget;
  let mainContentElem = document.querySelector('main, [role="main"], #main, #main-content');

  if (!mainContentElem) {
    const header = document.querySelector('header');
    if (header) {
      mainContentElem = header.nextElementSibling;
    }
  }

  if (!mainContentElem) {
    mainContentElem = document.body.firstElementChild;
  }

  if (!mainContentElem) return;

  // Ensure screen reader support
  if (mainContentElem.tagName === 'DIV' && !mainContentElem.hasAttribute('role')) {
    mainContentElem.setAttribute('role', 'main');
  }

  // Ensure focusability
  if (!mainContentElem.hasAttribute('tabindex')) {
    mainContentElem.setAttribute('tabindex', '-1');
  }

  // Ensure the target has an ID for the link
  if (!mainContentElem.id) {
    mainContentElem.id = 'main-content';
  }

  skipElem.setAttribute('href', `#${mainContentElem.id}`);

  document.activeElement?.blur(); // hides mobile keyboard if needed
  mainContentElem.scrollIntoView({ behavior: 'smooth' });
  mainContentElem.focus({ preventScroll: true });
}

document.addEventListener('DOMContentLoaded', () => {
  const skipButton = document.getElementById(SKIP_TO_MAIN_ID);
  if (!skipButton) {
    return;
  }
  skipButton.addEventListener('click', handleClick);
});